import React, { useState } from 'react';
import { formatNumber } from '../../utils/formats';

// SVG LOGOS
import brokenImg from '../../assets/img/broken-image-general.png';
import belmenySvg from '../../assets/img/logos/BELMENY-SVG.svg';
import ingcoSvg from '../../assets/img/logos/INGCO-SVG.svg';
import vertSvg from '../../assets/img/logos/VERT-SVG.svg';
import quilosaSvg from '../../assets/img/logos/QUILOSA-SVG.svg';
import fleximaticSvg from '../../assets/img/logos/FLEXIMATIC-SVG.svg';
import imouSvg from '../../assets/img/logos/IMOU-SVG.svg';
import coronaSvg from '../../assets/img/logos/CORONA-SVG.svg';
import wadfowSvg from '../../assets/img/logos/WADFOW-SVG.svg';

export const TopProductos2 = ({ topProductos = [] }) => {
  const [expanded, setExpanded] = useState({}); // map idx -> bool

  const handleImageError = (event) => {
    event.target.src = brokenImg;
  };

  const toggleExpanded = (idx) => {
    setExpanded(prev => ({ ...prev, [idx]: !prev[idx] }));
  };

  const sumTotalVendido = (topProductos || []).reduce((acc, productos) => {
    const totalVendidoVert = productos.TotalVendidoVert || 0;
    const totalVendidoIngco = productos.TotalVendidoIngco || 0;
    const totalVendidoImou = productos.TotalVendidoImou || 0;
    const totalVendidoWadfow = productos.TotalVendidoWadfow || 0;
    const totalVendidoCorona = productos.TotalVendidoCorona || 0;
    const totalVendidoFleximatic = productos.TotalVendidoFleximatic || 0;
    const totalVendidoQuilosa = productos.TotalVendidoQuilosa || 0;
    return (
      acc +
      totalVendidoVert +
      totalVendidoIngco +
      totalVendidoImou +
      totalVendidoWadfow +
      totalVendidoCorona +
      totalVendidoFleximatic +
      totalVendidoQuilosa
    );
  }, 0);

  const pctOfTotal = (value) => {
    if (!sumTotalVendido || sumTotalVendido === 0) return '0.00';
    return Number(((Number(value || 0) * 100) / sumTotalVendido)).toFixed(2);
  };

  const vendorTotal = (v) =>
    (v.TotalVendidoVert || 0) +
    (v.TotalVendidoIngco || 0) +
    (v.TotalVendidoImou || 0) +
    (v.TotalVendidoWadfow || 0) +
    (v.TotalVendidoCorona || 0) +
    (v.TotalVendidoFleximatic || 0) +
    (v.TotalVendidoQuilosa || 0);

  const BrandRowMobile = ({ logo, name, cantidad, ventas, porcentaje }) => (
    <div className="mobile-brand d-flex align-items-center bg-white rounded p-2 mb-2">
      <div style={{ width: 64, flexShrink: 0 }}>
        <img src={logo} alt={name} onError={handleImageError} style={{ width: 56, height: 'auto' }} loading="lazy" />
      </div>
      <div style={{ flex: 1, paddingLeft: 12 }}>
        <div className="d-flex justify-content-between align-items-baseline">
          <div style={{ fontWeight: 700 }}>{name}</div>
          <div className="text-success fw-bold">${formatNumber(Number(ventas || 0).toFixed(2))}</div>
        </div>
        <div className="d-flex justify-content-between small text-muted">
          <div>{cantidad || 0} productos</div>
          <div>{porcentaje}%</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="row">
      <div className="col">
        {/* DESKTOP: mantiene tu diseño original */}
        <div className="d-none d-md-block">
          <div className="m-auto bg-white p-3 rounded drop-shadow-card h-100">
            <h4 className="text-belmeny mb-3">Ventas por marca</h4>
            <h6 className="text-muted fw-normal mb-3">
              Para poder visualizar los datos haga click en el vendedor que desea ver y la tarjeta se expandirá
            </h6>

            <div className="container-fluid h-100">
              <div className="accordion mt-2" id="accordionVxC">
                {topProductos.map((vxc, idx) => {
                  const headingId = `heading-${idx}`;
                  const collapseId = `collapse-${idx}`;
                  return (
                    <div className="accordion-item" key={idx}>
                      <h2 className="accordion-header" id={headingId}>
                        <button
                          className="accordion-button collapsed"
                          type="button"
                          data-bs-toggle="collapse"
                          data-bs-target={`#${collapseId}`}
                          aria-expanded="false"
                          aria-controls={collapseId}
                        >
                          <span>{vxc.CodVendedor} - {vxc.Nombre}</span>
                        </button>
                      </h2>
                      <div
                        id={collapseId}
                        className="accordion-collapse collapse"
                        aria-labelledby={headingId}
                        data-bs-parent="#accordionVxC"
                      >
                        <div className="accordion-body">
                          <div className="row bg-belmeny3 text-white py-3 rounded">
                            <div className="col-3">
                              <h5 className="text-uppercase">Marca</h5>
                            </div>
                            <div className="col">
                              <h5 className="text-uppercase text-center">Productos Vendidos</h5>
                            </div>
                            <div className="col">
                              <h5 className="text-uppercase text-center">Ventas Generadas</h5>
                            </div>
                            <div className="col">
                              <h5 className="text-uppercase text-center">% Representado</h5>
                            </div>
                          </div>

                          {/* VERT */}
                          <div className="row mt-3">
                            <div className="col-3">
                              <h5 className="text-uppercase pt-1">
                                <img src={vertSvg} width={120} alt="VERT" onError={handleImageError} loading="lazy" />
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal">
                                {vxc.CantidadProductosVert || 0}
                                <span className="ps-1">Productos</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal text-success">
                                {vxc.TotalVendidoVert ? formatNumber(Number(vxc.TotalVendidoVert).toFixed(2)) : 0}
                                <span className="ps-1">USD</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal text-info">
                                {vxc.TotalVendidoVert ? pctOfTotal(vxc.TotalVendidoVert) : '0.00'}%
                              </h5>
                            </div>
                          </div>

                          {/* INGCO */}
                          <div className="row mt-3">
                            <div className="col-3">
                              <h5 className="text-uppercase">
                                <img src={ingcoSvg} width={120} alt="INGCO" onError={handleImageError} loading="lazy" />
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-2 fw-normal">
                                {vxc.CantidadProductosIngco || 0}
                                <span className="ps-1">Productos</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-2 fw-normal text-success">
                                {vxc.TotalVendidoIngco ? formatNumber(Number(vxc.TotalVendidoIngco).toFixed(2)) : 0}
                                <span className="ps-1">USD</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-2 fw-normal text-info">
                                {vxc.TotalVendidoIngco ? pctOfTotal(vxc.TotalVendidoIngco) : '0.00'}%
                              </h5>
                            </div>
                          </div>

                          {/* QUILOSA */}
                          <div className="row mt-3">
                            <div className="col-3">
                              <h5 className="text-uppercase">
                                <img src={quilosaSvg} width={120} alt="QUILOSA" onError={handleImageError} loading="lazy" />
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal">
                                {vxc.CantidadProductosQuilosa || 0}
                                <span className="ps-1">Productos</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal text-success">
                                {vxc.TotalVendidoQuilosa ? formatNumber(Number(vxc.TotalVendidoQuilosa).toFixed(2)) : 0}
                                <span className="ps-1">USD</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal text-info">
                                {vxc.TotalVendidoQuilosa ? pctOfTotal(vxc.TotalVendidoQuilosa) : '0.00'}%
                              </h5>
                            </div>
                          </div>

                          {/* IMOU */}
                          <div className="row mt-3">
                            <div className="col-3">
                              <h5 className="text-uppercase pt-1">
                                <img src={imouSvg} width={120} alt="IMOU" onError={handleImageError} loading="lazy" />
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal">
                                {vxc.CantidadProductosImou || 0}
                                <span className="ps-1">Productos</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal text-success">
                                {vxc.TotalVendidoImou ? formatNumber(Number(vxc.TotalVendidoImou).toFixed(2)) : 0}
                                <span className="ps-1">USD</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal text-info">
                                {vxc.TotalVendidoImou ? pctOfTotal(vxc.TotalVendidoImou) : '0.00'}%
                              </h5>
                            </div>
                          </div>

                          {/* FLEXIMATIC */}
                          <div className="row mt-3">
                            <div className="col-3">
                              <h5 className="text-uppercase pt-1">
                                <img src={fleximaticSvg} width={120} alt="FLEXIMATIC" onError={handleImageError} loading="lazy" />
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal">
                                {vxc.CantidadProductosFleximatic || 0}
                                <span className="ps-1">Productos</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal text-success">
                                {vxc.TotalVendidoFleximatic ? formatNumber(Number(vxc.TotalVendidoFleximatic).toFixed(2)) : 0}
                                <span className="ps-1">USD</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-4 fw-normal text-info">
                                {vxc.TotalVendidoFleximatic ? pctOfTotal(vxc.TotalVendidoFleximatic) : '0.00'}%
                              </h5>
                            </div>
                          </div>

                          {/* CORONA */}
                          <div className="row mt-3">
                            <div className="col-3">
                              <h5 className="text-uppercase pt-1">
                                <img src={coronaSvg} width={120} alt="CORONA" onError={handleImageError} loading="lazy" />
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-3 fw-normal">
                                {vxc.CantidadProductosCorona || 0}
                                <span className="ps-1">Productos</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-3 fw-normal text-success">
                                {vxc.TotalVendidoCorona ? formatNumber(Number(vxc.TotalVendidoCorona).toFixed(2)) : 0}
                                <span className="ps-1">USD</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-3 fw-normal text-info">
                                {vxc.TotalVendidoCorona ? pctOfTotal(vxc.TotalVendidoCorona) : '0.00'}%
                              </h5>
                            </div>
                          </div>

                          {/* WADFOW */}
                          <div className="row mt-4">
                            <div className="col-3">
                              <h5 className="text-uppercase pt-2">
                                <img src={wadfowSvg} width={120} alt="WADFOW" onError={handleImageError} loading="lazy" />
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-3 fw-normal">
                                {vxc.CantidadProductosWadfow || 0}
                                <span className="ps-1">Productos</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-3 fw-normal text-success">
                                {vxc.TotalVendidoWadfow ? formatNumber(Number(vxc.TotalVendidoWadfow).toFixed(2)) : 0}
                                <span className="ps-1">USD</span>
                              </h5>
                            </div>
                            <div className="col">
                              <h5 className="text-center text-uppercase pt-3 fw-normal text-info">
                                {vxc.TotalVendidoWadfow ? pctOfTotal(vxc.TotalVendidoWadfow) : '0.00'}%
                              </h5>
                            </div>
                          </div>
                          {/* Fin contenido de marcas */}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        {/* MOBILE: apilado + colapsable (por defecto todo cerrado) */}
        <div className="d-block d-md-none">
          <style>{`
            .topproductos2-mobile .vendedor-card { margin-bottom: 12px; }
            .topproductos2-mobile .vendedor-header { font-weight: 700; margin-bottom: 8px; }
            .topproductos2-mobile .mobile-brand { transition: box-shadow .12s ease; }
            .topproductos2-mobile .mobile-brand:hover { box-shadow: 0 6px 18px rgba(0,0,0,0.06); transform: translateY(-2px); }
            .topproductos2-mobile .expand-btn { cursor: pointer; }
            .topproductos2-mobile .card-body-collapsed { display: none; }
            .topproductos2-mobile .card-body-expanded { display: block; }
          `}</style>

          <div className="topproductos2-mobile">
            <div className="m-auto bg-white p-3 rounded drop-shadow-card h-100">
              <h4 className="text-belmeny mb-2">Ventas por marca</h4>
              <h6 className="text-muted fw-normal mb-3">Desglose por vendedor (toca para expandir)</h6>

              {topProductos && topProductos.length ? (
                topProductos.map((vxc, idx) => {
                  const isExpanded = !!expanded[idx];
                  return (
                    <div className="vendedor-card" key={idx}>
                      <div
                        className="bg-light rounded p-2 mb-2 d-flex justify-content-between align-items-center expand-btn"
                        role="button"
                        aria-expanded={isExpanded}
                        onClick={() => toggleExpanded(idx)}
                        onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') toggleExpanded(idx); }}
                        tabIndex={0}
                      >
                        <div className="vendedor-header">{vxc.CodVendedor} - {vxc.Nombre}</div>
                        <div className="text-muted small">{formatNumber(vendorTotal(vxc).toFixed(2))} USD</div>
                      </div>

                      <div className={isExpanded ? 'card-body-expanded' : 'card-body-collapsed'}>
                        <BrandRowMobile
                          logo={vertSvg}
                          name="VERT"
                          cantidad={vxc.CantidadProductosVert || 0}
                          ventas={vxc.TotalVendidoVert || 0}
                          porcentaje={pctOfTotal(vxc.TotalVendidoVert)}
                        />
                        <BrandRowMobile
                          logo={ingcoSvg}
                          name="INGCO"
                          cantidad={vxc.CantidadProductosIngco || 0}
                          ventas={vxc.TotalVendidoIngco || 0}
                          porcentaje={pctOfTotal(vxc.TotalVendidoIngco)}
                        />
                        <BrandRowMobile
                          logo={quilosaSvg}
                          name="QUILOSA"
                          cantidad={vxc.CantidadProductosQuilosa || 0}
                          ventas={vxc.TotalVendidoQuilosa || 0}
                          porcentaje={pctOfTotal(vxc.TotalVendidoQuilosa)}
                        />
                        <BrandRowMobile
                          logo={imouSvg}
                          name="IMOU"
                          cantidad={vxc.CantidadProductosImou || 0}
                          ventas={vxc.TotalVendidoImou || 0}
                          porcentaje={pctOfTotal(vxc.TotalVendidoImou)}
                        />
                        <BrandRowMobile
                          logo={fleximaticSvg}
                          name="FLEXIMATIC"
                          cantidad={vxc.CantidadProductosFleximatic || 0}
                          ventas={vxc.TotalVendidoFleximatic || 0}
                          porcentaje={pctOfTotal(vxc.TotalVendidoFleximatic)}
                        />
                        <BrandRowMobile
                          logo={coronaSvg}
                          name="CORONA"
                          cantidad={vxc.CantidadProductosCorona || 0}
                          ventas={vxc.TotalVendidoCorona || 0}
                          porcentaje={pctOfTotal(vxc.TotalVendidoCorona)}
                        />
                        <BrandRowMobile
                          logo={wadfowSvg}
                          name="WADFOW"
                          cantidad={vxc.CantidadProductosWadfow || 0}
                          ventas={vxc.TotalVendidoWadfow || 0}
                          porcentaje={pctOfTotal(vxc.TotalVendidoWadfow)}
                        />
                      </div>
                    </div>
                  );
                })
              ) : (
                <div className="text-muted">Sin datos para mostrar.</div>
              )}
            </div>
          </div>
        </div>

      </div>
    </div>
  );
};
